import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, Switch, Typography } from 'antd';

import { THEME } from '@/shared/constants/theme';
import { useTheme } from '@/shared/lib/hooks';

interface ThemeSwitcherProps {
    isMenu?: boolean;
}

export const ThemeSwitcher = memo((props: ThemeSwitcherProps) => {
    const { isMenu = false } = props;

    const { t } = useTranslation();

    const [theme, toggleTheme] = useTheme();

    const onToggleHandler = useCallback(() => {
        toggleTheme();
    }, [toggleTheme]);

    const switchComponent = (
        <Switch
            onChange={onToggleHandler}
            size="small"
            value={theme === THEME.dark}
        />
    );

    if (isMenu) {
        return (
            <Flex
                align="center"
                gap={16}
                justify="space-between"
            >
                <Typography.Text>
                    {t('colorTheme', {
                        theme:
                            theme === THEME.dark
                                ? t('darkTheme')
                                : t('lightTheme'),
                    })}
                </Typography.Text>
                {switchComponent}
            </Flex>
        );
    }

    return switchComponent;
});

ThemeSwitcher.displayName = 'ThemeSwitcher';
